import React from 'react'
import propTypes from 'prop-types'

import { Card } from '@components/layout/Card'
import { RiskProductsProvider } from './context'
import { Views } from './Views'
import { Header } from './components/Header'

export const RiskProducts = (props) => {
  return (
    <RiskProductsProvider {...props}>
      <Card className='ui-card--asset'>
        <Header />
        <Views />
      </Card>
    </RiskProductsProvider>
  )
}

RiskProducts.propTypes = {
  scenario: propTypes.shape({
    id: propTypes.number,
  }),

  riskProducts: propTypes.arrayOf(propTypes.object).isRequired,
  crudActions: propTypes.object,
  tenant: propTypes.object.isRequired,
  supportedRiskProductTypes: propTypes.arrayOf(propTypes.string).isRequired,
  serviceProviders: propTypes.arrayOf(propTypes.object).isRequired,
}
